import { AutomationProvider } from 'components/organisms/integrations/salesforce/create/automation-context';
import { CreateAutomationLayout } from 'components/organisms/integrations/salesforce/create/layout';

function AutomationCreatePage() {
  return (
    <AutomationProvider>
      <CreateAutomationLayout />
    </AutomationProvider>
  );
}

export { AutomationCreatePage };
